import { RequestStatus } from 'typed/api';
import { ActionType, Action } from 'typed/actions';
import { IReducer } from './';
import { Entity, IEntityReducerState, isNetworkArray, isSimpleArray, IEntityReducerCreator } from './entityReducers';
import { deepAssign, deepClone } from 'typed/utils';

const entityVoidAllReducer: IEntityReducerCreator = <E extends Entity, T extends ActionType>(def: IEntityReducerState<E>, type: T): IReducer<any, Action<T>> => {
    return function entityVoidAllReducer(state: IEntityReducerState<E> | undefined = deepClone(def), action: Action<T>): IEntityReducerState<E> {
        if (action.type === type) {
            if (isNetworkArray(state)) {
                return deepAssign(state, {
                    Custom: action.payload.immediately ? { status: RequestStatus.UNSYNCED } : { expires: new Date() }
                });
            }
            else if (isSimpleArray(state)) {
                return deepAssign<E>(state, state.map(_ => ({
                    Custom: action.payload.immediately ? { status: RequestStatus.UNSYNCED } as E['Custom'] : { expires: new Date() } as E['Custom']
                } as E)));
            }
            else {
                return deepAssign<E>(state, {
                    Custom: action.payload.immediately ? { status: RequestStatus.UNSYNCED } as E['Custom'] : { expires: new Date() } as E['Custom']
                } as E);
            }
        }
        return state;
    };
}

export default entityVoidAllReducer;